import Axios, {
  type AxiosHeaderValue,
  type InternalAxiosRequestConfig,
} from 'axios';

import { getToken } from '@/routes/(auth)/lib/token';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
  paramsSerializer: {
    indexes: null,
  },
});

AXIOS_INSTANCE.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }

    return config;
  }
);

type ParamValue = string | number | boolean | null | undefined;
export type ParamsType = Record<string, ParamValue | Array<ParamValue>>;

type CustomClient<T> = (data: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: ParamsType;
  headers?: Record<string, AxiosHeaderValue>;
  data?: unknown;
  signal?: AbortSignal;
}) => Promise<T>;

export function useCustomClient<T>(): CustomClient<T> {
  return async ({ method, params, data, url, headers, signal }): Promise<T> => {
    const response = await AXIOS_INSTANCE.request<T>({
      method,
      url,
      params,
      data,
      signal,
      headers: headers ?? {},
    });
    return response.data;
  };
}

export default useCustomClient;

export type ErrorType<ErrorData> = ErrorData;

export type BodyType<BodyData> = BodyData;
